var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 561.75 211.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#414042;}.cls-2{fill:#fff;}.cls-3{fill:#0d1216;}.cls-4{fill:#f8f7f4;}.cls-5{fill:#b2d9a0;}.cls-6{fill:#141414;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wave_background",
    "data-name": "Wave background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.06,195c-5.14,1.38-12.09,4.09-21.65-9.06s-19-15.36-54.81-1.82c0,0-23.1,6.37-45-14.74-10.36-10-30.16-16.22-55.73-12.87-25.57-3.35-45.36,2.89-55.72,12.87-21.91,21.11-45,14.74-45,14.74-35.86-13.54-45.82-6-55.38,7.17s-19.92,10.36-19.92,10.36c-26.29-11.55-39.44,10-39.44,10H488.33S473.14,188.8,450.06,195Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hills"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "449.38 126.18 448.53 126.18 448.53 102.8 446.29 102.8 443.97 92.35 420.21 92.35 416.87 100.72 416.87 104.54 407.74 104.54 407.74 103.69 416.02 103.69 416.02 100.55 419.64 91.5 444.65 91.5 446.97 101.95 449.38 101.95 449.38 126.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "474.29 135.83 463.05 129.32 463.05 112.91 459.7 104.54 456.92 104.54 456.92 110.65 454.6 113.55 454.6 123.53 444.51 128.87 444.11 128.13 453.76 123.02 453.76 113.26 456.08 110.35 456.08 103.69 460.27 103.69 463.89 112.74 463.89 128.84 474.71 135.1 474.29 135.83"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 456.5,
    y: 110.08,
    width: 2.9,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.63 102.8 436.44 102.8 434.62 96.1 435.43 95.88 437.09 101.95 446.63 101.95 446.63 102.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 446.12,
    y: 106.35,
    width: 0.84,
    height: 11.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hills-2",
    "data-name": "Hills"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.4 134.81 70.97 134.08 78.6 129.59 78.6 125.73 116.3 125.73 119.06 113.28 124.9 113.28 124.9 114.13 119.74 114.13 116.97 126.57 79.44 126.57 79.44 130.08 71.4 134.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.37,
    y: 132.41,
    width: 35.32,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.03,
    y: 134.71,
    width: 8.29,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "159.86 133.03 155.72 116.03 150 116.03 148.01 103.89 142.73 103.89 140.64 97.69 126.7 97.69 123.77 123.34 122.93 123.24 125.94 96.85 141.24 96.85 143.34 103.05 148.73 103.05 150.72 115.19 156.39 115.19 160.68 132.82 159.86 133.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.92,
    y: 115.53,
    width: 0.84,
    height: 12.3,
    transform: "translate(-17.63 25.98) rotate(-9.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 130.78,
    y: 99.33,
    width: 3.47,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.22,
    y: 116.55,
    width: 15.68,
    height: 0.84,
    transform: "translate(-1.46 232.34) rotate(-84.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.93,
    y: 145.17,
    width: 18.09,
    height: 0.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.68 125.73 168.88 125.48 170.66 119.84 173.73 119.84 176.26 108.3 185.67 108.3 188.55 122.71 187.73 122.88 184.98 109.14 176.94 109.14 174.41 120.68 171.28 120.68 169.68 125.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 187.08,
    y: 116.34,
    width: 11.19,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Power_pole",
    "data-name": "Power pole"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.48,48.61c-55.87,0-116-13.45-151.92-35.49l.44-.72C256.77,39.88,339.37,54,404.15,45.16c29.53-4,64.16-30.38,64.51-30.65l.51.67A217.42,217.42,0,0,1,448,29.05C436.64,35.61,419.82,43.88,404.27,46A304.72,304.72,0,0,1,363.48,48.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.59,
    width: 4.83,
    height: 157.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 203.9,
    y: 14.83,
    width: 46.22,
    height: 5.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.31,9.31v4.83a2.77,2.77,0,0,0,2.76,2.76h0a2.76,2.76,0,0,0,2.76-2.76V9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.07,17.32a3.19,3.19,0,0,1-3.18-3.18V8.89h6.36v5.25A3.18,3.18,0,0,1,209.07,17.32Zm-2.33-7.59v4.41a2.34,2.34,0,1,0,4.67,0V9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.18,9.31v4.83a2.77,2.77,0,0,0,2.76,2.76h0a2.76,2.76,0,0,0,2.76-2.76V9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.94,17.32a3.19,3.19,0,0,1-3.18-3.18V8.89h6.36v5.25A3.18,3.18,0,0,1,244.94,17.32Zm-2.33-7.59v4.41a2.34,2.34,0,1,0,4.67,0V9.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.26,34.08a75.11,75.11,0,0,1-27.09-4.91C96.39,21.58,86.35,7.63,86.25,7.49L86.94,7c.1.14,10,13.91,29.57,21.4,18.06,6.92,48.26,9.75,89.64-16l.11-.07h5.23v.85h-5c-18.37,11.42-36.11,18.24-52.73,20.27A85.44,85.44,0,0,1,143.26,34.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.06,46.08l-3.9,0c-21.74-.33-46.08-3.37-72.34-9a556.57,556.57,0,0,1-80.23-23.86h-4.8C230,22.42,218.24,28.57,206.69,32c-10.56,3.11-19.87,3.59-27.35,4a211.86,211.86,0,0,1-77.77-10.15c-18.09-6.06-28.26-12.63-28.36-12.7l.46-.7c.1.06,10.2,6.59,28.2,12.61a210.87,210.87,0,0,0,77.42,10.09c16.09-.82,34.32-1.76,63.11-22.72l.11-.08h5.25l.07,0A552.9,552.9,0,0,0,328,36.2c41.16,8.87,99,15.67,140.74-2.38l.33.77C451.44,42.22,429.58,46.08,404.06,46.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 222.95,
    y: 14.41,
    width: 7.7,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 501.8,
    y: 116.94,
    width: 30.96,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 545.43,
    y: 108.78,
    width: 7.32,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.43,
    y: 108.78,
    width: 33.29,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 539.23,
    y: 113.28,
    width: 22.52,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 495.89,
    y: 113.28,
    width: 36.87,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 477.87,
    y: 113.28,
    width: 10.1,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud-2",
    "data-name": "Cloud"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 23.93,
    y: 108.44,
    width: 30.96,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.56,
    y: 100.28,
    width: 33.29,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.01,
    y: 104.78,
    width: 36.87,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 104.78,
    width: 10.1,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud-3",
    "data-name": "Cloud"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 421.41,
    y: 81.59,
    width: 27.04,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 426.33,
    y: 74.46,
    width: 29.08,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 416.25,
    y: 78.4,
    width: 32.2,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 400.52,
    y: 78.4,
    width: 8.82,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud-4",
    "data-name": "Cloud"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 154.29,
    y: 67.8,
    width: 27.04,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 142.65,
    y: 64.61,
    width: 32.2,
    height: 0.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 126.92,
    y: 64.61,
    width: 8.82,
    height: 0.84
  })), /*#__PURE__*/React.createElement("g", {
    id: "Car"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "428.96 191.11 413.38 196.82 362.28 196.82 362.28 149.25 428.87 149.25 428.96 191.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.22,185.28c0,12.92-1.3,23.83-11.52,25.4-.86.13-8.33-.06-9.22-.06-11.45,0-20.73-11.34-20.73-25.34s9.28-25.34,20.73-25.34S412.22,171.29,412.22,185.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 400.96,
    cy: 185.28,
    rx: 20.73,
    ry: 25.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401,211.33c-11.83,0-21.44-11.69-21.44-26.05s9.61-26,21.44-26,21.43,11.68,21.43,26S412.78,211.33,401,211.33Zm0-50.69c-11,0-20,11.06-20,24.64s9,24.64,20,24.64,20-11,20-24.64S412,160.64,401,160.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 400.88,
    cy: 185.78,
    rx: 13.25,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 333.59,
    cy: 182.89,
    rx: 27.02,
    ry: 27.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 182.67,
    y: 149.11,
    width: 74.76,
    height: 48.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.89,185.28c0,12.92-1.3,23.83-11.52,25.4-.86.13-8.33-.06-9.22-.06-11.45,0-20.73-11.34-20.73-25.34s9.28-25.34,20.73-25.34S234.89,171.29,234.89,185.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 157.38,
    cy: 182.89,
    rx: 27.02,
    ry: 27.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M441.67,172.08c0,3-.12,5.72-.23,8-.21,4.07-.47,6.64-.47,6.64l-16.33,5.63c1-22.24-8.17-31.07-15.46-34.57a21.07,21.07,0,0,0-16.05-.79c-22.15,7.75-17.74,40.71-17.74,40.71H247.88c2.59-23.51-5.08-33.66-12.06-38.28a21.73,21.73,0,0,0-16.74-3.09c-25.38,6-20.74,41.37-20.74,41.37H114.17l-5.34-15.49s0-.09,0-.14c-.06-2.9,0-5.53.2-7.91,1.08-14,5.9-19.31,7.21-20.52l.34-.28c20-14.07,75.15-18.58,75.15-18.58l.19-.13c23-16.31,43.48-24.89,56.86-29.27a108.89,108.89,0,0,1,16.28-4.23c67.55-9.85,94.73.95,123,13.51,17.61,7.82,47.29,20,47.29,20q.26.45.48.9a34.65,34.65,0,0,1,1.53,3.49,57.34,57.34,0,0,1,2.76,10.61c.15.83.28,1.66.4,2.5A137.59,137.59,0,0,1,441.67,172.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.39,198.09h-128l.06-.47c2-18.56-2-31.3-11.87-37.88a21.3,21.3,0,0,0-16.41-3c-10.36,2.47-16.94,10.08-19.58,22.63a61.85,61.85,0,0,0-.85,18.27l.07.48H113.87l-5.47-15.84V182a78.76,78.76,0,0,1,.2-7.94c1.09-14,5.9-19.46,7.35-20.8a3.69,3.69,0,0,1,.37-.31c10.39-7.32,30.34-12,45.24-14.64,15.34-2.72,28.63-3.89,30-4l.09-.06c23.19-16.42,43.79-25,57-29.34A112.42,112.42,0,0,1,265,100.7c31.07-4.53,55.33-5,76.37-1.65,18.45,3,32.15,8.65,46.87,15.19,17.4,7.73,47,19.86,47.28,20l.14.06.07.13c.16.29.33.6.49.91a33.78,33.78,0,0,1,1.55,3.53,58.67,58.67,0,0,1,2.78,10.69c.15.91.28,1.73.39,2.51a135.37,135.37,0,0,1,1.18,20c0,2.58-.1,5.27-.24,8-.2,4-.47,6.64-.47,6.66l0,.27-17.17,5.92,0-.62c1-21.71-7.72-30.57-15.22-34.17a20.49,20.49,0,0,0-15.73-.77c-9,3.16-14.71,10.87-16.9,22.92a63.1,63.1,0,0,0-.57,17.33l.07.48Zm-127-.85H374.91a64.5,64.5,0,0,1,.62-17.09c2.21-12.21,8.25-20.36,17.46-23.59a21.28,21.28,0,0,1,16.37.81c7.66,3.68,16.57,12.63,15.73,34.35l15.49-5.34c.07-.76.27-3.08.44-6.35.13-2.71.21-5.38.23-7.95h0a135.23,135.23,0,0,0-1.16-19.91c-.11-.78-.24-1.59-.39-2.48A57.84,57.84,0,0,0,437,139.15a34.21,34.21,0,0,0-1.51-3.44c-.14-.26-.27-.52-.41-.76-2.21-.91-30.36-12.47-47.16-19.93-26.14-11.62-53.18-23.63-122.77-13.48a107.72,107.72,0,0,0-16.21,4.21c-13.14,4.3-33.64,12.86-56.75,29.22l-.28.2h-.11c-.56,0-55.29,4.65-74.95,18.5h0s-.11.08-.29.24c-1.39,1.29-6,6.53-7.08,20.24-.19,2.47-.26,5.11-.2,7.87v.08l5.22,15.13h83.39a63.17,63.17,0,0,1,.92-18.08c2.67-12.71,9.65-20.76,20.2-23.27A22.14,22.14,0,0,1,236.05,159a26.21,26.21,0,0,1,9.78,12.26C248.6,178.09,249.44,186.82,248.35,197.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "274.76 132.36 274.42 141.28 269.41 141.76 271.52 132.36 274.76 132.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.87,142.24l2.31-10.3h4l-.37,9.72Zm3-9.46L270,141.29l4.06-.4.31-8.11Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 223.62,
    cy: 185.28,
    rx: 20.73,
    ry: 25.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.62,211.33c-11.82,0-21.43-11.69-21.43-26.05s9.61-26,21.43-26,21.44,11.68,21.44,26S235.44,211.33,223.62,211.33Zm0-50.69c-11,0-20,11.06-20,24.64s9,24.64,20,24.64,20-11,20-24.64S234.67,160.64,223.62,160.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M252.48,143.81l.06-.8a14.84,14.84,0,0,1,4-8.87c.61-.66,1.25-1.33,2-2.06A92.34,92.34,0,0,1,298,108c13.84-4.19,24.1-3.6,24.2-3.59h.09c1.68.09,3.36.21,5.18.36.91.07,1.84.16,2.85.26,4.83.48,9.74,1.16,14.59,2,35.48,6.35,60.55,21.18,60.8,21.33l1.1.66Zm68.21-38.64a80.16,80.16,0,0,0-22.44,3.58,91.52,91.52,0,0,0-39.17,23.92c-.71.72-1.35,1.39-1.95,2a14.06,14.06,0,0,0-3.73,8.16l150.74-14.46a202.24,202.24,0,0,0-59.37-20.57c-4.83-.86-9.72-1.55-14.52-2-1-.1-1.94-.19-2.84-.26-1.81-.15-3.49-.27-5.13-.36h-.12S321.62,105.17,320.69,105.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.89,107.08a108.08,108.08,0,0,0-23,13.4h0c-1.77,1.31-3.44,2.61-5,3.88l0,0c-2.44,2-4.62,3.83-6.47,5.49-4.25,3.78-6.79,6.41-6.79,6.41l-55.68-1.68c23-16.31,43.48-24.89,56.86-29.27l3.16-.1,2.66-.06c2.1,0,4.23,0,6.36,0l3.09,0c10.4.12,20.22.61,24.68.86A.54.54,0,0,1,288.89,107.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.77,136.73h-.19l-57-1.72,1-.73c23.19-16.42,43.79-25,57-29.34h.05l3.23-.1,2.67-.06c2,0,4.17,0,6.36,0H264c10.27.12,19.88.59,24.7.86a1,1,0,0,1,.9.81.94.94,0,0,1-.59,1h0a106.12,106.12,0,0,0-22.89,13.35c-1.66,1.24-3.34,2.54-5,3.88l0,0c-2.19,1.76-4.36,3.61-6.45,5.47-4.19,3.73-6.74,6.37-6.76,6.4Zm-54.58-2.49,54.23,1.64c.58-.59,3-3,6.67-6.31,2.11-1.87,4.29-3.72,6.5-5.5l0,0c1.67-1.34,3.35-2.65,5-3.88a107.57,107.57,0,0,1,23.09-13.46h0a.12.12,0,0,0,.08-.13.11.11,0,0,0-.12-.1c-4.81-.27-14.41-.74-24.65-.86h-.24l-2.85,0c-2.19,0-4.33,0-6.35,0-.89,0-1.78,0-2.66.06l-3.1.09C235.9,110,215.83,118.38,193.19,134.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M370.32,190.21H252.52l.28-46.59h.85l-.28,45.74H369.91a64.9,64.9,0,0,1,3-16c3.7-11.31,10.27-18.73,19-21.46a28.25,28.25,0,0,1,23.84,3c8.27,5.49,13.35,15.86,14.7,30l-.84.08c-1.32-13.87-6.28-24-14.33-29.36a27.35,27.35,0,0,0-23.12-2.93c-10.67,3.33-15.91,13.2-18.43,20.89a62.81,62.81,0,0,0-2.95,16.15v.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "328.94 189.81 328.1 189.76 330.91 143.25 328.82 136.43 329.63 136.18 331.76 143.15 331.76 143.22 328.94 189.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "388.87 159.21 388.02 159.17 389.03 138.12 383.88 130.99 384.56 130.5 389.89 137.86 388.87 159.21"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 223.55,
    cy: 185.78,
    rx: 13.25,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.48,197.39c-5.25,0-9.52-5.18-9.52-11.54s4.27-11.55,9.52-11.55,9.53,5.18,9.53,11.55S228.73,197.39,223.48,197.39Zm0-22.25c-4.78,0-8.68,4.81-8.68,10.71s3.9,10.7,8.68,10.7,8.68-4.8,8.68-10.7S228.27,175.14,223.48,175.14Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 223.22,
    cy: 185.92,
    rx: 2.36,
    ry: 2.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 401.11,
    cy: 185.92,
    rx: 2.36,
    ry: 2.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M401.1,197.39c-5.26,0-9.53-5.18-9.53-11.54s4.27-11.55,9.53-11.55,9.52,5.18,9.52,11.55S406.35,197.39,401.1,197.39Zm0-22.25c-4.79,0-8.68,4.81-8.68,10.71s3.89,10.7,8.68,10.7,8.68-4.8,8.68-10.7S405.88,175.14,401.1,175.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.67,146.58s-2.12,1-5,2.74c-4.14,2.47-9.86,6.33-13,10.49l-31.29,6.61-3.33.7s-10.39,2.46-15.32,7.25a5.14,5.14,0,0,1-3.57,1.48H113.19a13.71,13.71,0,0,1-4.17-1.72q.17-2.19.45-4.11c.07-.48.15-1,.23-1.4.26-1.49.56-2.85.89-4.08.13-.49.27-1,.41-1.41a33.11,33.11,0,0,1,1.53-4c.24-.51.48-1,.71-1.4a15.86,15.86,0,0,1,3-4.09H152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.14,176.27h-20a14.44,14.44,0,0,1-4.31-1.78l-.22-.13,0-.26c.11-1.42.26-2.82.46-4.14.07-.48.14-1,.22-1.41.26-1.46.56-2.85.9-4.12.14-.51.28-1,.42-1.42a30.6,30.6,0,0,1,1.55-4.08c.23-.49.47-1,.72-1.44A16.26,16.26,0,0,1,116,153.3l.12-.11H152l55.19-7.38L204.85,147s-2.14,1-5,2.73c-4.17,2.47-9.79,6.29-12.9,10.37l-.09.13-.16,0-34.62,7.32c-.09,0-10.32,2.48-15.12,7.14A5.52,5.52,0,0,1,133.14,176.27Zm-19.91-.84h19.91a4.66,4.66,0,0,0,3.27-1.36c5-4.82,15.1-7.25,15.53-7.36l34.47-7.28c3.21-4.15,8.85-8,13.05-10.47,1.09-.65,2.09-1.21,2.89-1.65L152.06,154H116.4a15.45,15.45,0,0,0-2.79,3.86c-.24.44-.47.91-.69,1.38a32.61,32.61,0,0,0-1.52,4c-.14.43-.27.89-.4,1.39-.34,1.25-.64,2.61-.89,4-.07.45-.15.92-.22,1.4-.18,1.22-.32,2.5-.43,3.81A13.87,13.87,0,0,0,113.23,175.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.37,189.92H111.5l-2.67-7.74s0-.09,0-.14h23.86a5,5,0,0,1,4.61,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.67,149.32c-4.14,2.47-9.86,6.33-13,10.49l-31.29,6.61c-2.35-1.55-4.36-3.41-4.17-5.21.42-4.08,5.63-5.06,5.63-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.28,166.87l-.15-.1c-3.07-2-4.54-3.9-4.36-5.6.45-4.34,5.74-5.39,6-5.44l45-7.17-1.9,1.13c-4.17,2.47-9.79,6.29-12.9,10.37l-.09.13-.16,0Zm42.35-16.79-40.75,6.48s-4.89,1-5.27,4.7c-.14,1.31,1.19,2.94,3.84,4.71l31-6.54C189.17,155.86,193.74,152.52,197.63,150.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.68,158.4h0a.7.7,0,0,1-.7.7H112.53c.24-.51.48-1,.71-1.4H146A.7.7,0,0,1,146.68,158.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111,163.13h32a.71.71,0,0,1,.7.7h0a.71.71,0,0,1-.7.71H110.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.7,168.62h30.37a.7.7,0,0,1,.7.7h0a.7.7,0,0,1-.7.7h-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.6,189.92l0-.84,14.3-.28c14.08-1.22,18.73-6.4,19.61-7.58l-4.17-4.94L145.8,177l-13.43,6.44-.36-.76,13.59-6.51h.09l22-.71,4.83,5.73-.15.26c-.16.28-4.09,6.82-20.45,8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.54,184.74l-.85,0c0-.18,1-18.24,12.26-27.86,5.67-4.82,13-6.76,21.71-5.76,10.46,1.21,22.46,10.41,25.7,28.25l-.83.15c-3.16-17.42-14.82-26.39-25-27.56-8.49-1-15.57.9-21.06,5.57C195.48,166.86,194.54,184.56,194.54,184.74Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 163.71,
    cy: 181.2,
    rx: 2.25,
    ry: 2.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.37,157.27a1.8,1.8,0,1,1-1.77-2.11A2,2,0,0,1,179.37,157.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171.21,158.68a1.81,1.81,0,1,1-1.78-2.11A2,2,0,0,1,171.21,158.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 161.27,
    cy: 160.37,
    rx: 1.78,
    ry: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.3,134.77l-3.6.34-44.84,4.31c.06-2.89-.57-18.7,1.45-19.58,4.5-2,11.74-.77,15.31.06a4.74,4.74,0,0,1,3.63,4l-.37,9.7,27.59-4.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "252.98 151.36 252.9 150.52 409.03 135.74 437.64 138.98 437.55 139.82 409.02 136.59 252.98 151.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 252.61,
    y: 180.67,
    width: 120.6,
    height: 0.84,
    transform: "translate(-17.2 33.67) rotate(-6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.15,129.17l-13.32-.61,0-.84,11.52.52a5.29,5.29,0,0,1-.91-3.52,6,6,0,0,1,2.06-3.67l.52.67-.26-.34.26.34a5.15,5.15,0,0,0-1.74,3.1,4.85,4.85,0,0,0,1.25,3.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "137.78 186.15 137.4 185.4 147.01 180.64 161.46 180.64 161.46 181.48 147.21 181.48 137.78 186.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.5,128.7l-66.8,6.41-8.41-29.71C373.76,109.71,405.5,128.7,405.5,128.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M379.2,116.77l5.05,13.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 381.31,
    y: 116.32,
    width: 0.84,
    height: 14.66,
    transform: "translate(-19.23 138.98) rotate(-20.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373,123.21H352.44a5.76,5.76,0,0,0-5.36,3.67l-3,7.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M344.47,134.75l-.79-.31,3-7.71a6.12,6.12,0,0,1,5.75-3.94H373v.85H352.44a5.29,5.29,0,0,0-5,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344.84,107.43,338.65,130l-9.57.56s-1.73-15.81-30.95-22.18c13.93-4.21,24.06-3.57,24.06-3.57q4.11.21,8.1.62C335.31,105.89,340.17,106.59,344.84,107.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.59,135.41l-.77.07-10.6,1-1.92-31.72c1.74.1,3.45.22,5.15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.83,137l-2-32.62.48,0c1.65.09,3.33.21,5.15.36l.3,0,.07.29,8.28,30.75Zm-1.08-31.73L324.62,136l10.44-1-7.94-29.51C325.59,105.41,324.16,105.31,322.75,105.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267,140.31a7.32,7.32,0,0,1-.2,1.7l-13.88,1.33,0-.3a14.31,14.31,0,0,1,3.85-8.62c.65-.7,1.3-1.38,2-2C263.36,132.57,267,136.05,267,140.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.41 189.93 112.56 182.04 111.07 182.04 113.92 189.93 115.41 189.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.91 189.93 118.42 189.93 115.57 182.04 117.07 182.04 119.91 189.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.42 189.93 121.57 182.04 120.08 182.04 122.92 189.93 124.42 189.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.92 189.93 127.43 189.93 124.58 182.04 126.08 182.04 128.92 189.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.42 189.93 130.58 182.04 129.08 182.04 131.93 189.93 133.42 189.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "143.37 197.89 139.84 192.18 115.3 192.18 115.3 191.33 140.31 191.33 144.09 197.44 143.37 197.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M254.59,105.19c-18,7.25-36.41,23.65-36.41,23.65l36.2,1c-4.25,3.78-6.79,6.41-6.79,6.41l-55.68-1.68c23-16.31,43.48-24.89,56.86-29.27l3.16-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M265.91,120.48h0l-5,3.88,0,0,.1-19.24,3.09,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 204.76,
    y: 144.4,
    width: 48.1,
    height: 0.84,
    transform: "translate(-9.24 15.74) rotate(-3.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 302.34,
    y: 138.18,
    width: 0.84,
    height: 8.06,
    transform: "translate(100.27 408.46) rotate(-77.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 302.34,
    y: 136.65,
    width: 0.84,
    height: 6.06,
    transform: "translate(-30.22 122.43) rotate(-21.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M325.83,147.68a3.3,3.3,0,0,1-3.3-3.22l.85,0a2.45,2.45,0,0,0,2.7,2.38l5-.52.09.84-5,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.1,142.05a3.3,3.3,0,0,1-3.3-3.22l.84,0a2.45,2.45,0,0,0,.84,1.78,2.4,2.4,0,0,0,1.87.6l5-.52.09.84-5,.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.51,152.11c-15.12-4.06-18.82-14.51-18.82-14.51l15.66,1.4a57.34,57.34,0,0,1,2.76,10.61C440.26,150.44,440.39,151.27,440.51,152.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M441,152.69l-.61-.17c-15.16-4.07-19.07-14.67-19.11-14.78l-.22-.62,16.58,1.48.1.25a58.67,58.67,0,0,1,2.78,10.69c.15.91.28,1.73.39,2.51Zm-18.65-14.61c1.07,2.25,5.52,10,17.63,13.45-.08-.58-.18-1.19-.29-1.85a58,58,0,0,0-2.65-10.28Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "288.06 112.51 289.23 134.6 275.03 136.5 265.91 126.01 275.79 118.77 288.06 112.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,120.25,324,132.89l-10.14.74.37-9.7h0a4.08,4.08,0,0,0-2.4-3.55h0l-7.57-11.18,2.73.2a19,19,0,0,1,15.74,10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.91,131.76l-.63-11.45s2.54.23,2.85-3.13c0,0,0-2.83-2-2l-1.63-3.81-9.76-.69s-4.18,14.64,2.56,13.94l-.26,7.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.56,132.93l.26-7.87h0a3.15,3.15,0,0,1-2.55-1.14c-2.78-3.32-.07-13,.05-13.37l.09-.33,10.36.74,1.58,3.69a1.6,1.6,0,0,1,1.26.19c.92.61,1,2.16,1,2.33v0c-.25,2.81-2,3.39-2.83,3.5l.64,11.44Zm1.14-8.79-.26,7.87,8-.64-.64-11.52.48,0c.22,0,2.13.08,2.4-2.73,0-.34-.13-1.31-.59-1.62-.08-.05-.32-.21-.87,0l-.38.16-1.69-4-9.16-.66c-.45,1.72-2.35,9.61-.12,12.27a2.46,2.46,0,0,0,2.32.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M298.49,116s-1.78-1.55-2.79,1.74l-1,.23-1.55-6.25s-8.9,1.08-11.28-2.32a2.49,2.49,0,0,1,.4-3.27c.7-.58,1.81-.78,3.44.75,0,0-.7-4.3,2.56-2.78,1.1.51,2.09,2.27,4.18,2.53,0,0,3.49,0,3.72,2.28C296.16,109,299.88,108.34,298.49,116Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.33,121.94a5.77,5.77,0,0,1-4.19,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M288.22,125.14l-.15-.83a5.32,5.32,0,0,0,3.88-2.55l.76.36A6.15,6.15,0,0,1,288.22,125.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.72,126l-3.85.41a7.58,7.58,0,0,0-6.39,5.13l-4,9.61L294.59,140l2.47,10.24s13.73,7,16.31-.45c2.18-6.31-7.79-25.19-7.79-25.19A7.15,7.15,0,0,0,296,126S288.18,134.68,287.72,126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.94,141.32s0,6.13-1.83,8.42L288,140.29l-6.59.28s2.39-4.7,6.06-4.24S298.94,141.32,298.94,141.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.14,150.38l-9.28-9.66-7.13.3.33-.64c.11-.2,2.57-5,6.49-4.47,3.7.46,11.29,4.86,11.61,5.05l.21.12v.24c0,.26,0,6.31-1.93,8.69Zm-8.94-10.52,8.86,9.22c1.27-2.11,1.44-6.44,1.46-7.51-1.27-.73-7.87-4.43-11.08-4.83-2.53-.31-4.46,2.16-5.24,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.42,125.57l-3.12,2.72a10.31,10.31,0,0,1,9.77,10.29,9.92,9.92,0,0,1-.42,2.9l3.38-.31a13.87,13.87,0,0,0,.25-2.59A13.54,13.54,0,0,0,266.42,125.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.1,133.43l-.42,1.45s-5.49-4.79-5.13-6.22,2.94-1.92,5.39,2.93A2.45,2.45,0,0,1,276.1,133.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.9,135.63l-.5-.43c-1.33-1.17-5.65-5.08-5.26-6.65a1.69,1.69,0,0,1,1.49-1.25c.75-.08,2.69.15,4.69,4.1a3,3,0,0,1,.19,2.15h0Zm-4-7.5h-.14a.85.85,0,0,0-.77.62c-.16.66,2.11,3.21,4.5,5.36l.24-.81h0a2.08,2.08,0,0,0-.14-1.53C274.2,129.08,272.79,128.13,271.87,128.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Leaf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M491.64,159.78a22.36,22.36,0,0,0-9.68,8.33,9.52,9.52,0,0,1,4.37,1.6c2.08,1.47,3.13,3.76,3.11,6.8a5.82,5.82,0,0,1-3.76,4.65c-1.3.38-3.25.18-5.2-2.88a8.72,8.72,0,0,1-.68-7.14,13.12,13.12,0,0,1,.9-2.34,17.23,17.23,0,0,0-6.21,1,132,132,0,0,1-14.33,4.36l-.18-.76a132.71,132.71,0,0,0,14.24-4.34,18,18,0,0,1,6.88-1,22.88,22.88,0,0,1,10.19-9Zm-11.09,11.58a8,8,0,0,0,.59,6.5c1.34,2.09,2.83,3,4.32,2.55a5.09,5.09,0,0,0,3.19-3.9,7,7,0,0,0-2.78-6.16,9,9,0,0,0-4.32-1.5A13.68,13.68,0,0,0,480.55,171.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.88,174.69c-6.41.75-8.33-.39-8.35-.41l-.42.67c.09.05,2.17,1.31,8.86.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M512.51,153.67a17.66,17.66,0,0,0-5.66-2.78c-3.75-.93-8.4.73-7.31,4.67C500.26,158.16,506.07,158.52,512.51,153.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.69,153.78a49.15,49.15,0,0,0-9.42,3l.31.72a48.75,48.75,0,0,1,9.25-2.94Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/Footer.5740dc71eb276fa1ec6b2f26915bbe04.svg";
export { ForwardRef as ReactComponent };